var map = {
	"./CommentCount.importable": [
		8639,
		331,
		327,
		639
	],
	"./EditionDropdown.importable": [
		6965,
		331,
		965
	],
	"./GetMatchStats.importable": [
		3639,
		331,
		327,
		665
	],
	"./InstagramBlockComponent.importable": [
		343,
		331,
		624,
		343
	],
	"./Links.importable": [
		2602,
		331,
		327,
		602
	],
	"./MostViewedRightWrapper.importable": [
		5440,
		331,
		327,
		195,
		440
	],
	"./RichLinkComponent.importable": [
		1126,
		331,
		327,
		126
	],
	"./SpotifyBlockComponent.importable": [
		7597,
		331,
		624,
		597
	],
	"./SubNav.importable": [
		6348,
		331,
		348
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;